// extracted by mini-css-extract-plugin
module.exports = {"importButton":"AddTokenButton_importButton__3Nasv","tooltip":"AddTokenButton_tooltip__2Q8ht"};